import CheckoutView from './CheckoutView';

export default CheckoutView;
